import WhatsAppIcon from "./WhatsAppIcon";
import { waLink, DEFAULT_WA_MSG } from "../lib/site";

export default function FloatingWhatsApp() {
    return (
        <a
            data-testid="floating-whatsapp"
            href={waLink(DEFAULT_WA_MSG)}
            target="_blank"
            rel="noopener noreferrer"
            className="group fixed bottom-5 right-5 z-50 flex items-center gap-3"
            aria-label="Falar com a Magnus no WhatsApp"
        >
            <span className="hidden md:inline-block bg-white border border-gold/30 shadow-frame rounded-full px-4 py-2 font-body text-xs font-medium text-ink opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
                Fale com a Magnus no WhatsApp
            </span>
            <span className="animate-wa-pulse flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg group-hover:bg-[#1EBE57] group-hover:scale-105 transition-all duration-300">
                <WhatsAppIcon size={26} />
            </span>
        </a>
    );
}
